import React from 'react';
import './Sidebar.css';

export default function Sidebar({
  companies, workspaceId, workspaceName, groups, activeId, notificationCount,
  isOpen, isPinned, onToggle, onPreview, onLeave, onWorkspaceChange, onNavigate,
  onCustomize, onLogout, loading, error, onRetry,
}) {
  const holding = workspaceId === 'holding';
  return <div className={`workspace-sidebar-shell${isOpen ? ' is-open' : ''}`} onMouseLeave={onLeave}>
    <aside className="workspace-sidebar" aria-label="Workspace sidebar" aria-hidden={!isOpen || undefined} inert={!isOpen}>
      <div className="workspace-sidebar-heading">
        <div className="workspace-sidebar-label-row">
          <label htmlFor="workspace-navigation-select">Active workspace</label>
          {!holding && <button type="button" className="workspace-notifications" aria-label={notificationCount ? `Notifications, ${notificationCount} unread` : 'Notifications'} onClick={() => onNavigate('/company/notifications')}>
            <span className="workspace-notifications-symbol" aria-hidden="true">🔔</span>
            {notificationCount > 0 && <span className="workspace-notification-count">{notificationCount > 99 ? '99+' : notificationCount}</span>}
          </button>}
        </div>
        <select id="workspace-navigation-select" value={workspaceId} onChange={event => onWorkspaceChange(event.target.value)}>
          <option value="holding">Access LB Holding</option>
          {!holding && !companies.some(company => String(company.id) === workspaceId) && <option value={workspaceId}>{workspaceName}</option>}
          <optgroup label="Companies">{companies.map(company => <option key={company.id} value={company.id}>{company.name}</option>)}</optgroup>
        </select>
      </div>
      <nav className="workspace-primary-nav" aria-label="Main navigation">
        {!holding && <button type="button" className="workspace-back" onClick={() => onWorkspaceChange('holding')}>← Back to Holding</button>}
        {groups.map(group => <button type="button" key={group.id} className={`workspace-module${activeId === group.id ? ' is-active' : ''}`} aria-current={activeId === group.id ? 'page' : undefined} onClick={() => onNavigate(group.items[0][0], group)}>
          <span>{group.title}</span>
        </button>)}
        {loading && <p className="workspace-sidebar-message" role="status">Loading company modules…</p>}
        {error && <div className="workspace-sidebar-message" role="alert"><p>{error}</p><button type="button" onClick={onRetry}>Try again</button></div>}
      </nav>
      <div className="workspace-sidebar-footer">
        <button type="button" className="workspace-customize-button" onClick={onCustomize}><span aria-hidden="true">☷</span> Customize sidebar</button>
        <button type="button" className="workspace-logout" onClick={onLogout}>Logout</button>
      </div>
    </aside>
    <button type="button" className="workspace-sidebar-toggle" aria-label={isPinned ? 'Close sidebar' : 'Pin sidebar open'} aria-expanded={isOpen} aria-pressed={isPinned} onMouseEnter={onPreview} onClick={onToggle}>{isOpen ? '‹' : '›'}</button>
  </div>;
}
